import { StaffEntity } from '@/entities/staff.entity';
import APIBuilder from '@quangphuc/frontend-api-builder';

export default class CurrentUserService {
  apiPrefix = 'authentication/staff';

  async update(userData: Partial<StaffEntity>): Promise<StaffEntity> {
    const { data } = await APIBuilder.axios.patch<StaffEntity>(
      this.apiPrefix,
      userData,
    );
    return data;
  }

  async uploadAvatar(avatar: File): Promise<StaffEntity> {
    const formData = new FormData();
    formData.append('avatar', avatar);
    const { data } = await APIBuilder.axios.patch<StaffEntity>(
      this.apiPrefix,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
    );
    return data;
  }
}
